export const ALEIS_NXM_SCANNER_DRIVER_NAME = "aleisnxm-scanner";
